import { indentElements } from './elementsAdapters';
import { getFamilyIds } from '@editor2/services/storeService';
import { ElementConfigName } from '@editor2/types/pageElements';
import { renumberChapterPages } from './helpers';

export const applyNoConflictingDiff = (state, nodes: any[]) => {
	nodes.forEach((item) => {
		switch (true) {
			case item.type === 'NG::Traditional::Book': {
				state.book = { ...state.book, ...item };
				break;
			}

			case item.type === 'NG::Soomo::LectureSlideDeck': {
				state.lecture_slide_decks.entities[item.family_id] = item;
				state.initialCourse.lecture_slide_decks.entities[item.family_id] = item;
				break;
			}

			case item.type === 'NG::Traditional::Chapter': {
				const { pages, page_groups, ...chapter } = item;

				state.chapters.entities[item.family_id] = {
					...chapter,
					...(chapter.page_groups_enabled && { page_groups: getFamilyIds(page_groups) }),
					...(!chapter.page_groups_enabled && { pages: getFamilyIds(pages) })
				};
				break;
			}

			case item.type === 'NG::Traditional::PageGroup': {
				const { pages, ...pageGroup } = item;

				state.page_groups.entities[item.family_id] = {
					...pageGroup,
					pages: getFamilyIds(pages)
				};
				break;
			}

			case item.type === 'NG::Traditional::Page': {
				const { elements, ...page } = item;
				const currentPage = state.pages.entities[item.family_id];

				state.pages.entities[item.family_id] = {
					currentPageNumber: currentPage?.currentPageNumber,
					...page,
					...(currentPage?.elements && { elements: getFamilyIds(elements) })
				};

				currentPage?.elements && indentElements(state, getFamilyIds(elements));
				break;
			}

			case !!ElementConfigName[item.type]: {
				const currentElement = state.elements.entities[item.family_id];
				if (currentElement) {
					state.elements.entities[item.family_id] = { ...currentElement, ...item };
				}
				break;
			}

			case !!item['chapters']:
				state.chapters.ids = item['chapters'];
				break;

			case !!item['lecture_slide_decks']:
				state.lecture_slide_decks.ids = item['lecture_slide_decks'];
				break;

			default:
				break;
		}
	});

	state.chapters.ids.map((chapterId) =>
		renumberChapterPages(state, state.chapters.entities[chapterId])
	);

	return state;
};
